import { FormattedMessage } from 'react-intl';
import { Text } from 'ui-components/components/text';
import FormattedCurrency from '../../../../../../components/formatted-currency';
import { computeAbsoluteEaches } from '../../../../../../constants/units-of-measure';
import { ProductColumn } from './columns/product-column';
import { ReceivedColumn } from './columns/received-column';
import { messages } from './product-grid-columns.messages';
import styles from './product-grid-columns.styles.module.less';

export const getProductGridColumns = (openProductDetails, currencyCode, isUnitsOfMeasureEnabled = false) => [
  {
    Header: <FormattedMessage {...messages.productNameColumnHeader} />,
    accessor: 'name',
    isSortable: true,
    Cell: ({ row }) => <ProductColumn data={row.original} openProductDetails={openProductDetails} />,
    width: 300,
  },
  {
    Header: <FormattedMessage {...messages.receivedColumnHeader} />,
    accessor: 'totalOrdered',
    Cell: ({ row }) => <ReceivedColumn data={row.original} />,
    width: 200,
  },
  {
    Header: <FormattedMessage {...messages.costColumnHeader} />,
    accessor: 'cost',
    Cell: ({ value }) => (
      <div className={styles['cost-column']}>
        <Text value={<FormattedCurrency currencyCode={currencyCode} value={value} />} />
      </div>
    ),
    width: 100,
  },
  {
    Header: <FormattedMessage {...messages.totalCostColumnHeader} />,
    accessor: 'quantity',
    Cell: ({ row }) => {
      const qty = row.original.quantity ?? 0;
      const cost = row.original.cost ?? 0;
      const absoluteEaches =
        isUnitsOfMeasureEnabled && (row.original.unitOfMeasure ?? 0) > 0
          ? computeAbsoluteEaches(row.original.unitOfMeasure, row.original.unitsOfMeasure ?? [])
          : 1;
      return (
        <div className={styles['cost-column']}>
          <Text value={<FormattedCurrency currencyCode={currencyCode} value={qty * cost * absoluteEaches} />} />
        </div>
      );
    },
    width: 100,
  },
];
